<section class="search-filter" [formGroup]="searchForm">
  <div class="search-container">
    <div *ngIf="isLoggedIn" class="search-container-item">
      <div class="d-flex">
        <label for="partNumberInput" class="required">
          {{ 'mySiteEquipment.enterPartNumber' | cxTranslate }}
        </label>
        <span
          class="material-icons-outlined"
          (mouseenter)="showPartNoInfo = true"
          (mouseleave)="showPartNoInfo = false"
        >info</span>
      </div>
      <div *ngIf="showPartNoInfo" class="col-1 view-validation-info">
        <div class="dropdown set-position-partNO-info p-0">
          <div class="breakdown-price">
            {{ 'rma-form.partNumberInfoText' | cxTranslate }}
          </div>
        </div>
      </div>
      <div class="part-number-input position-relative">
        <input
          #partNumberInput
          id="partNumberInput"
          class="input-container"
          placeholder="{{ 'mySiteEquipment.enterPartNumber' | cxTranslate }}"
          maxlength="18"
          formControlName="partNumber"
          (input)="autoSearchResults($event)"
          [value]="selectedPart?.code || ''"
          autocomplete="off"
        />
        <div class="input-message">
          <span class="material-icons-outlined">info</span>
          {{'mySiteEquipment.inputMessage' | cxTranslate}}
        </div>
        <span
          *ngIf="selectedPart"
          class="material-icons"
          (click)="clearPartSelection()"
        >close</span>      
        <div
          *ngIf="searchingProducts && !selectedPart"
          class="part-input-side-loader side-loader cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
        <div
          class="part-number-suggestions"
          *ngIf="openSuggestions && !selectedPart"
          [clickSourceId]="partNumberInput"
          (clickOutside)="openSuggestions = false"
        >
          <a
            class="part-number-autocomplete"
            *ngFor="let part of  $any(parts | slice: 0 : 5)"
            (click)="selectPart(part)"
          >
            <cx-media
              class="col-2 p-0 part-image"
              [container]="part.images"
              format="thumbnail"
              [alt]="part.summary"
            ></cx-media>
            <div class="col-10 product-details-holder">
              <div class="part-name">{{ part.name }}</div>
              <div class="part-number-code">{{ part.code }}</div>
            </div>
          </a>
          <div
            *ngIf="!searchingProducts && parts.length === 0"
            class="no-results-message"
          >
            <div class="no-matching-parts">
              {{ 'rma-form.noMatchingParts' | cxTranslate }}
            </div>
            <a class="find-similar-btn" (click)="openHelpSearch()">
              {{ 'rma-form.findSimilar' | cxTranslate }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isLoggedIn" class="search-container-item">
      <div class="d-flex">
        <label for="serialNumber">
          {{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}
        </label>
        <span
          class="material-icons-outlined"
          (mouseenter)="showserialNOInfo = true"
          (mouseleave)="showserialNOInfo = false"
        >info</span>
      </div>
      <div *ngIf="showserialNOInfo" class="col-1 view-validation-info">
        <div class="dropdown set-position-serialNO-info p-0">
          <div class="breakdown-price">
            {{ 'rma-form.serialNumberInfoText' | cxTranslate }}
          </div>
        </div>
      </div>
      <div class="part-number-input">
        <input
          #serialInput
          id="serialNumber"
          class="input-container"
          formControlName="serialNumber"
          autocomplete="off"
          placeholder="{{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}"
          maxlength="18"
          [value]="selectedPart?.summary || ''"
          (input)="autoSearchSerial($event)"
        />
        </div>
        </div>
    <!-- Serial Number Search -->
      <div *ngIf="!isLoggedIn" class="serial-input-wrapper">
      <div class="d-flex">
        <label class="serial-label">
          {{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}
          <span class="required1">*</span>
        </label>
        <span
        class="material-icons-outlined iconmaterial"
        (mouseenter)="showserialNOInfo = true"
        (mouseleave)="showserialNOInfo = false"
        >info</span>
      </div>
         <div *ngIf="showserialNOInfo" class="col-1 view-validation-info">
      <div class="dropdown set-position-serialNO-info p-0">
        <div class="breakdown-price">
          {{ 'rma-form.serialNumberInfoText' | cxTranslate }}
        </div>
      </div>
    </div>
        <div class="serial-search-row">
          <div class="serial-input-container">
            <input
             #serialInput id="serialNumber" class="serial-input" formControlName="serialNumber"
                autocomplete="off" placeholder="{{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}" maxlength="18"
                [value]="selectedPart?.summary || ''"  />
            <span class="input-close"
            *ngIf="searchForm.get('serialNumber')?.value"
            (click)="clearSerialNumber()"
            >×</span>
          </div> 
          <bh-button
          type="primary"
          label="Search"
          (click)=searchSerialNumberproduct()
          >
        </bh-button>
        <bh-button
        label="contact Details"
        
        style="visibility :hidden;"></bh-button>
      </div>
      <div class="validation-error"
      *ngIf="searchForm.get('serialNumber')?.touched && searchForm.get('serialNumber')?.hasError('required')">
    Serial number is required
    </div>
    </div>
      <div *ngIf="isLoggedIn">
      <div
        *ngIf="searchingResults"
        class="part-input-side-loader side-loader cx-spinner"
      >
        <cx-spinner></cx-spinner>
      </div>
      </div>
        <!-- <div *ngIf="!isLoggedIn" >
          <div class="serial-search-row">
            <div serial-input-container>
              <div class="serial-input-wrapper">
              <input #serialInput id="serialNumber" class="serial-input" formControlName="serialNumber"
                autocomplete="off" placeholder="{{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}" maxlength="18"
                [value]="selectedPart?.summary || ''" (input)="autoSearchSerial($event)" />
                </div>
                </div>
          
        <div *ngIf="!isLoggedIn" class="col-1"> <bh-button type="primary" [label]="'Search'" [disabled]="searchForm.get('serialNumber')?.invalid"
            (click)="searchSerialNumberproduct()"></bh-button></div>
            </div> -->
          <!-- <div class="col-md-8">
            <div class="part-number-input position-relative">
              <input #serialInput id="serialNumber" class="input-container" formControlName="serialNumber"
                autocomplete="off" placeholder="{{ 'mySiteEquipment.enterSerialNUmber' | cxTranslate }}" maxlength="18"
                [value]="selectedPart?.summary || ''" (input)="autoSearchSerial($event)" />
                
            class="part-number-suggestions"
            *ngIf="openSerialSuggestions  && !disableSerialSearch"
            [clickSourceId]="serialInput"
            (clickOutside)="openSerialSuggestions = false"
          >
            <a
              class="part-number-autocomplete"
              *ngFor="let product of serialSearchResults | slice: 0 : 5"
              (click)="selectSerial(product)"
            >
              <cx-media
                class="col-2 p-0 part-image"
                [container]="product.images"
                format="thumbnail"
                [alt]="product.name"
              ></cx-media>
              <div class="col-10 product-details-holder">
                <div class="part-name">{{ product.name }}</div>
                <div class="part-number-code">
                  {{ product.code }}
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-3">
            <bh-button type="primary" [label]="'Search'" [disabled]="searchForm.get('serialNumber')?.invalid">
            </bh-button>
          </div> -->
        
  </div>
</section>
<div *ngIf="!isLoggedIn">
<div 
  class="serial-product-result"
  *ngIf="confirmedProduct"
>
  <!-- Product Image -->
  <div class="serial-product-image">
    <cx-media
      class="confirm-product-img"
      [container]="productImageContainer"
      format="product"
      [alt]="confirmedProduct?.images?.[0]?.altText">
    </cx-media>
    </div>
 
  <!-- Product Information -->
  <div class="serial-product-details">
    <div class="serial-product-name">
      {{ confirmedProduct?.shipToName }}
    </div>
 
    <div class="serial-product-description">
      {{ confirmedProduct?.partDescription }}
    </div>
    
    <div class="serial-product-info" >
      
      Serial # : {{ confirmedProduct?.serialNumber }}
    </div>
 
    <div class="serial-product-info">
      Part # : {{ confirmedProduct?.partNumber }}
    </div>
 
    <a class="serial-product-view-details"
    (click)="viewProductDetails()"
    >
      View Details
    </a>
  </div>
</div>
</div>